import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class CloudGuardSaaSColoredIcon extends BaseIcon {
  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#e45785' : this.getColor()
    return [
      <g>
        <path fill={ color }
              d="M28.43,35A16,16,0,0,1,43.92,24.77a22.83,22.83,0,0,1,6,.82c0-.18,0-.36,0-.54a11.83,11.83,0,0,0-9.5-11.57,13.75,13.75,0,0,0-26.87-2.67,13.55,13.55,0,0,0-1.43-.08A12.14,12.14,0,0,0,11.43,35v0Z"/>
        <path fill={ '#fff' }
              d="M35.19,12.5v-.36a1,1,0,0,0-.78-1,16.3,16.3,0,0,1-5.92-2.63h0a7.56,7.56,0,0,1-1.21-1,1,1,0,0,0-1.52,1.34A9.49,9.49,0,0,0,27,10h0a17.58,17.58,0,0,0,6.14,3c0,2.38-.05,7.46-1,9.12a8.94,8.94,0,0,1-5.63,4,8.85,8.85,0,0,1-5.64-4c-.95-1.66-1-6.74-1-9.12a17.78,17.78,0,0,0,5.84-2.75A9.9,9.9,0,0,1,25,9.48a1.92,1.92,0,0,1-.46-1,16.09,16.09,0,0,1-5.91,2.62,1,1,0,0,0-.78,1v.36c0,4.11.14,8.58,1.27,10.55a10.92,10.92,0,0,0,7.23,5h.31a10.88,10.88,0,0,0,7.23-5C35.05,21.08,35.19,16.61,35.19,12.5Z"/>
      </g>
    ]
  }
  getViewBox = () => '0 0 50 36'
}
